import React from 'react';
import { Route } from 'react-router';
import ParentPortalLayout from './components/parent_portal/ParentPortalLayout';
import Billing from './components/parent_portal/billing/Billing';
import PaymentProfile from './components/parent_portal/billing/PaymentProfile';
import BillingAccount from './components/parent_portal/billing/BillingAccount';
import ChecklistAnswerLinker from './components/parent_portal/ChecklistAnswerLinker';

export default () => <Route path='/portal' component={ParentPortalLayout}>
  <Route
    path={'billing/payment_profile'}
    components={PaymentProfile}
  />

  <Route
    path='billing'
    components={Billing}
  />

  <Route
    path={'billing/accounts/:billing_account_id'}
    components={BillingAccount}
  />


  <Route
    path={'checklist_answer_links'}
    components={ChecklistAnswerLinker}
  />
</Route>;
